import React, { useEffect } from 'react';
import { FaPlay, FaYoutube } from 'react-icons/fa';
import { FaMicrophoneLines } from 'react-icons/fa6';
import radioMain from '../Images/workBg3.webp';

function Work() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='mt-16'>
            <div className="relative">
                <img src={radioMain} alt="Podcast background with a microphone" className=" w-full h-[250px] object-cover" />
            </div>
            <div className="bg-white flex items-center justify-center px-4 md:px-16">
                <div className="flex flex-col md:flex-row items-center p-6 md:p-12">
                    <div className="bg-purple-100 rounded-lg p-4 md:p-6 mb-6 md:mb-0 md:mr-6">
                        <a href="https://youtu.be/hRXPvHOctjg?si=iLhpi7zeV_AG3ln3" target='blank'>
                            <iframe className="h-[250px] w-full md:w-[400px] rounded-lg mb-4" src="https://www.youtube.com/embed/hRXPvHOctjg?si=iLhpi7zeV_AG3ln3" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            {/* <img src={workMain} alt="Podcast microphone setup" className="h-[250px] w-full md:w-[400px] rounded-lg mb-4" /> */}
                        </a>
                        <div className="flex items-center justify-center space-x-2">
                            <span className="text-black font-semibold">Watch our videos on</span>
                            <FaYoutube className="text-2xl text-red-500 mr-2" />
                        </div>
                    </div>
                    <div className="text-center md:text-left">
                        <div className="flex items-center justify-center md:justify-start mb-2">
                            <FaMicrophoneLines className="fas fa-podcast text-xl text-[#140047] mr-2" />
                            <span className="text-[#140047] font-bold">Real Talk</span>
                        </div>
                        <h1 className="text-3xl md:text-5xl font-bold text-black leading-tight mb-4">
                            The <span className="text-[#6633f2]"> 4 - hours Web Dev<br /></span> Challenge
                        </h1>
                        <p className="text-gray-800 mb-6">
                            Learning coding for fun
                        </p>
                        <div className='flex items-center justify-center md:justify-normal'>
                            <a href="https://youtu.be/hRXPvHOctjg?si=iLhpi7zeV_AG3ln3" target='blank'>
                                <button className="flex items-center text-white bg-pink-500 px-4 rounded-full text-sm font-bold transition duration-300 py-3 hover:bg-gradient-to-r hover:from-[#e00a7e] hover:to-[#6c32ee]">
                                    Watch video on Youtube<FaPlay className="fas fa-play ml-2 " />
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex justify-center items-center py-8 mb-10">
                <div className="flex flex-wrap justify-center">

                    <div
                        className="bg-gradient-to-br from-[#10003b] to-[#6c32ee] text-white rounded-lg p-6 m-4 max-w-md shadow-lg 
                 transition-all duration-300 ease-in-out 
                 hover:bg-gradient-to-br hover:from-[#e00a7e] hover:to-[#6c32ee] hover:bg-opacity-25
                 hover:scale-[1.03] 
                 hover:shadow-2xl"
                    >
                        <div className="bg-yellow-400 text-black font-medium rounded-full px-3 py-1 inline-block mb-4">
                            SERIES 1 : EPISODE 2
                        </div>
                        <h2 className="text-2xl font-bold mb-4">The 4 - Hour Web Dev Challenge</h2>
                        <p className="mb-6">The 4-hour Web Dev Challenge by Learn with Stack is an exciting and fast-paced mini-hackathon designed to push developers' skills to the limit. Participants are given a prompt and a set of tools to use, and they have 30 minutes to plan their project before diving into 4 hours of coding. The goal is to build a functional web app that meets the challenge requirements.</p>
                        <div className="flex items-center">
                            <div className="bg-white text-purple-700 rounded-full p-2 mr-2 
                        transition-transform duration-300 ease-in-out 
                        group-hover:rotate-180">
                                <FaPlay className="fas fa-play" />
                            </div>
                            <a href="https://youtu.be/hRXPvHOctjg?si=iLhpi7zeV_AG3ln3" target='blank'>
                                <button className=' bg-white/80 hover:bg-white/80 px-3 py-2 rounded-full '>
                                    <span className="text-black font-medium">Watch Video On Youtube</span>
                                </button>
                            </a>
                        </div>
                    </div>
                    <div
                        className="bg-gradient-to-br from-[#10003b] to-[#6c32ee] text-white rounded-lg p-6 m-4 max-w-md shadow-lg 
                 transition-all duration-300 ease-in-out 
                 hover:bg-gradient-to-br hover:from-[#e00a7e] hover:to-[#6c32ee] hover:bg-opacity-25
                 hover:scale-[1.03] 
                 hover:shadow-2xl"
                    >
                        <div className="bg-yellow-400 text-black rounded-full px-3 py-1 inline-block mb-4">
                            SERIES 2
                        </div>
                        <h2 className="text-2xl font-bold mb-4">Product Packaging and Graphic Designing</h2>
                        <p className="mb-6">Coming Soon...</p>
                        <div className="flex items-center">
                            <div className="bg-white text-purple-700 rounded-full p-2 mr-2 
                        transition-transform duration-300 ease-in-out 
                        group-hover:rotate-180">
                                <FaPlay className="fas fa-play" />
                            </div>
                            <button className=' bg-white/80 hover:bg-white/60 px-3 py-2 rounded-full '>
                                <span className="text-black">Coming Soon on Youtube</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Work;